/* eslint-disable max-len */
import React from 'react'
import { motion } from "framer-motion";
import { useSelector } from 'react-redux';


const AnimatedList = ({ child, keyItem ,id,rowStatus,handleClick,cursorpointer,isPatientTemplateTable,isSelectTemplateModalOpen,selectedIndex,hoverId}) => {
    const selectedId=useSelector((state)=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const selectedRows=selectedId.map((item)=>item.id)

    return (
        <motion.tr
            key={keyItem}
            id= {isPatientTemplateTable===undefined?"list-items":`${keyItem}choosetemplate`}
            onClick={(e)=>{
                if(handleClick){
                    handleClick(e)
                }
            }}
    
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 0 }}
            exit={{ opacity: 0, x: 0}}   
            transition={{ duration: 0.15 }}
            className={`${selectedRows.includes(id)||(isPatientTemplateTable!==undefined&&selectedIndex!==undefined&&selectedIndex===id||(hoverId&&isSelectTemplateModalOpen))?"bg-[#F8EEF1]":"bg-[#FFFFFF]"} rounded-[2px] hover:bg-[#F8EEF1] table-tr ${cursorpointer ? 'cursor-pointer' : ''}`}
        >
            {child}
        </motion.tr>
    );
}

export default AnimatedList;